import '../scripts/utilities/loadJqueryZoom';
import pageInitialiser from './helper/page_initialiser';
import page from '../scripts/_pages/product_page';
pageInitialiser(page);